import React, { Component } from 'react';
import { Element } from 'react-scroll';
import { Submenu } from '../components';

export default (props) => (
  <div className="Content Introducao-Content">

  	<span className="Mob-Title"> <h3 className="red-txt"> Introdução </h3> </span>

    <h2> Orientação sobre <br/> o conteúdo do Guia </h2>

    <Submenu
      links={[
        { to: "lideres-da-marca", title: "Líderes da marca", offset:-190 },
        { to: "lideres-e-profissionais-de-rh", title: "Líderes e <br/>Profissionais de RH", offset: -100 },
        { to: "comercial-e-atendimento-ao-cliente", title: "Comercial e <br/>atendimento ao cliente", offset: -100 },
        { to: "colaboradores", title: "Colaboradores", offset: -100 },
        { to: "marketing", title: "Marketing", offset: -100 },
        { to: "agências-de-comunicação", title: "Agências de <br/>Comunicação", offset: -340 }
      ]} />

    <Element name="lideres-da-marca" className="Block">

    	<div className="Text-Wrapper Text-Left">
    		<h1 className="red-txt"> Líderes <br/> da marca </h1>

    		<p> Para os líderes, este Guia pode ajudar em tomada de
    		decisões em todos os níveis e áreas. Em contratações, nas
    		decisões de investimento, no dia a dia da gestão. A cada escolha,
    		cabe a reflexão: que decisão está mais próxima de quem a Brasal é de
    		fato? Esta decisão, postura ou atitude corresponde à verdade da marca? </p>

      <p><strong> O exercício da cultura é um comportamento diário, vivo, dinâmico, que
			é praticado em todos os momentos. É papel dos líderes dar o exemplo, ser o
			espelho, a referência ao mesmo tempo em que estimula sua equipe a manter a
			chama da cultura sempre viva, relembrando suas orientações todo o tempo. </strong></p>

    	</div>

    	<div className="Img-Wrapper Center">
    		<img src={require("../img/Intro/lider.jpg")}/>
    	</div>

    </Element>

    <Element name="lideres-e-profissionais-de-rh" className="Block Over-Block">

    	<span className="Mob-Title"> <h1> Líderes e <br/> profissionais <br/> de rh </h1> </span>

		  <div className="bg-Overlap left">
	   		<img src={require("../img/Intro/bg-profissionais-rh.jpg")}/>
	   	</div>

	    <div className="Overlap">
		    <div className="Text-Wrapper">
		    	<h1> Líderes e <br/> profissionais de rh </h1>

		    	<p> Todo profissional de RH deve absorver, entender e internalizar com
		    	consciência a Cultura de Realização Brasal. Este é o primeiro passo para que
		    	se consiga contribuir efetivamente com o projeto maior a que este Guia se
		    	destina. A cultura se pratica a partir da ação humana, por meio de
		    	comportamentos, atitudes, postura, manifestações e escolhas. Por isso é
		    	fundamental que esta área tenha total clareza e domínio sobre a identidade
		    	da marca Brasal. </p>

    			<p> Em relação a novos colaboradores, é fundamental manter sempre um olhar
    			apurado e clínico sobre o perfil das contratações e cruzar essas características
    			com atributos, valores e essência da marca descritos neste documento. </p>

        	<p> Quanto ao que se refere à equipe atual, é importante estimular comportamentos
        	que sejam condizentes com a identidade da marca e implementar iniciativas que
        	reconheçam e recompensem os colaboradores que colocarem em prática a Cultura de Realização Brasal.
          É preciso ter a consciência de que é a postura diária que consolida a cultura
        	e a transforma em uma atitude natural e legítima. </p>

		    </div>
		</div>
    </Element>

    <Element name="comercial-e-atendimento-ao-cliente" className="Block">

  		<div className="Text-Wrapper Content-Ajust">
	    	<h1 className="red-txt"> Comercial e <br/> atendimento ao cliente </h1>

	    	<p className="p-ajust"> Mais adiante, este Guia deixa claro que a cultura Brasal está diretamente ligada às
	    	atividades que têm contato direto com os clientes da marca. E reforça que sua identidade
	    	sempre foi agir com energia e coragem a partir do conhecimento e do entendimento das
	    	necessidades do ser humano. </p>

			<p className="p-ajust"> Nessa dinâmica de aplicação da cultura, tem-se na linha de frente do atendimento
			verdadeiros agentes de observação e análise do ser humano. É papel fundamental dos
			profissionais dessa área a observação absoluta das pessoas, suas preferências, seus gostos,
			seus traços de comportamento. Percepção, sensibilidade e humildade para ouvir e entender são
			indispensáveis nesse processo. </p>

			<p className="p-ajust"> Nesse contexto, tudo é importante. Por isso é necessário estar sempre atentos, alertas
			e preparados para absorver, analisar e filtrar acontecimentos do dia a dia, para que eles se
			transformem em informações valiosas que podem determinar o futuro da empresa. </p>
    	</div>
    </Element>

    <Element name="colaboradores" className="Block">

    	<div className="Img-Wrapper Left">
    		<img src={require("../img/Intro/colaboradores.jpg")}/>
    	</div>

    	<div className="Text-Wrapper Text-Right">
    		<h1> Colaboradores </h1>

    		<p> Os colaboradores têm a tarefa de entender e aplicar a Cultura de Realização Brasal todos os dias. Observar as pessoas,
    		ouvir, ser proativo, colocar em prática as diretrizes, orientações e a identidade Brasal em seu comportamento,
    		em suas decisões e reflexões. </p>

      <p><strong> Exercitar é a chave para transformar esse processo em algo natural no jeito de ser, pensar e agir no ambiente
			de trabalho. </strong></p>

    	</div>
    </Element>

    <Element name="marketing" className="Block Red-Block">

    	<div className="Text-Wrapper Content-Ajust white-txt">
	    	<h1> Marketing </h1>

	    	<p className="p-ajust"> Para os profissionais de marketing, este Guia é uma
	    	ferramenta de suporte em praticamente todas as suas tarefas e atividades do dia a dia. Embora seja importante, assim
	    	como para todos os outros colaboradores, entender e executar a cultura Brasal, nesta área a responsabilidade vai
	    	além. </p>

			<p className="p-ajust"> O profissional de marketing é o responsável por orientar, conduzir e implementar
			a aplicação deste documento em suas duas partes, tanto da identidade da marca quanto das suas matrizes de expressão,
			que estão diretamente ligadas a uma das grandes ferramentas do marketing: a comunicação. </p>

			<p className="p-ajust"> Além de cuidar com diligência para que a comunicação – interna e externa – siga as
			orientações do Guia, o marketing deve implementar procedimentos e ferramentas que sirvam de suporte para que as
			outras áreas tenham estrutura para aplicar orientações e princípios deste documento. </p>

    	</div>

    </Element>

    <Element name="agências-de-comunicação" className="Block Black-Block">

    	<div className="Text-Wrapper Content-Ajust white-txt">
	    	<h1> Agências de <br/> Comunicação </h1>

	    	<p className="p-ajust"> Para as agências, um detalhe importante: o Guia não é um limitador, é um briefing
	    	detalhado. É possível ser criativo dentro das orientações definidas por este documento. O que mais importa é
	    	entender seu conteúdo e internalizá-lo mentalmente. Compreender a Brasal como uma persona é um exercício
	    	interessante nesse sentido. O primeiro passo é entender a fundo qual a identidade da marca. Assim é possível,
	      depois de cada peça ou ação criada, refletir: Essa é a Brasal de verdade? Esse é o segredo principal. Esse
	    	questionamento deve ser feito em todos os momentos. </p>

			<p className="p-ajust"> Além disso, seguir com rigor as orientações práticas das matrizes de expressão na
			elaboração dos textos, na escolha e tratamento das imagens, no tom de voz, nas decisões de produção impressa
			e audiovisual, na escolha da tipografa e nos outros elementos da atividade publicitária. </p>


    	</div>

    </Element>

  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Introducao.js